import * as React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import SideMenu, { SideMenuLink, SideMenuTitle } from '@amzn/meridian/side-menu';

import oskarAnimated from '../../../assets/trash-animated.gif';
import oskarStill from '../../../assets/trash-still.gif';
import { LinkData } from '../AppNavigator/FeatureLinks';
import { FEATURE_LINKS } from '../AppNavigator/FeatureLinks';

interface Props {
    isSideBarOpen: boolean;
}

export const SideBar: React.FC<Props> = (props) => {
    const { isSideBarOpen } = props;

    const navigate = useNavigate();
    const location = useLocation();
    const handleLinkClick = (linkData: LinkData) => {
        navigate(linkData.link);
    };

    return (
        <SideMenu open={isSideBarOpen}>
            <SideMenuTitle>Features</SideMenuTitle>
            {FEATURE_LINKS.map((linkData) => {
                return (
                    <SideMenuLink
                        key={linkData.id}
                        selected={location.pathname === linkData.link}
                        onClick={() => handleLinkClick(linkData)}
                    >
                        {linkData.text}
                    </SideMenuLink>
                );
            })}

            {/*
                Easter Egg: ListORama is the successor of IMDbOskarService.
                The following gif from the late OskarAdmin lives on here.
            */}
            <img
                src={oskarStill}
                alt='Oskar'
                width={50}
                onMouseOver={(e) => (e.currentTarget.src = oskarAnimated)}
                onMouseOut={(e) => (e.currentTarget.src = oskarStill)}
            />
        </SideMenu>
    );
};
